import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const CalendarEnd = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="19"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.08398 0.975342C5.4982 0.975342 5.83398 1.31113 5.83398 1.72534V2.97534H10.834V1.72534C10.834 1.31113 11.1698 0.975342 11.584 0.975342C11.9982 0.975342 12.334 1.31113 12.334 1.72534V2.97534H13.084C14.6034 2.97534 15.834 4.20737 15.834 5.72534V10.5963C15.834 11.0106 15.4982 11.3463 15.084 11.3463C14.6698 11.3463 14.334 11.0106 14.334 10.5963V7.97534H2.33398V14.2253C2.33398 14.9154 2.89344 15.4753 3.58398 15.4753H8.34998C8.7642 15.4753 9.09998 15.8111 9.09998 16.2253C9.09998 16.6396 8.7642 16.9753 8.34998 16.9753H3.58398C2.06453 16.9753 0.833984 15.7433 0.833984 14.2253V5.72534C0.833984 4.20737 2.06453 2.97534 3.58398 2.97534H4.33398V1.72534C4.33398 1.31113 4.66977 0.975342 5.08398 0.975342ZM13.084 4.47534C13.7745 4.47534 14.334 5.03531 14.334 5.72534V6.47534H2.33398V5.72534C2.33398 5.03531 2.89344 4.47534 3.58398 4.47534H13.084Z"
          fill="#ADACA8"
        />
        <path
          d="M16.4326 13.4272C16.6821 13.0966 16.6164 12.6263 16.2858 12.3767C15.9553 12.1272 15.4849 12.1929 15.2354 12.5235L12.3397 16.3593L11.3394 15.4267C11.0364 15.1443 10.5618 15.1609 10.2794 15.4639C9.99694 15.7669 10.0136 16.2415 10.3166 16.5239L11.9256 18.0239C12.0809 18.1688 12.2904 18.2409 12.5021 18.2225C12.7137 18.2041 12.9076 18.0967 13.0356 17.9272L16.4326 13.4272Z"
          fill="#ADACA8"
        />
      </svg>
    </SvgIcon>
  )
}

export default CalendarEnd
